var path = '/pages/downloads/views/downloading.tpl.html';
var html = "<section ng-if=\"!vm.downloading && !vm.error\">\n    <div class=\"dashboard-empty\">\n        <div class=\"pacman\">\n            <i class=\"fal fa-sync fa-spin\"></i>\n            <h2>Preparing download file</h2>\n        </div>\n    </div>\n</section>\n\n<section ng-if=\"vm.downloading\">\n    <h3>Download started.</h3>\n</section>\n<section ng-if=\"vm.error\">\n    <h3>Error occurred!</h3>\n</section>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/downloads/views/downloading.tpl.html
// module id = 2246
// module chunks = 1